import { PersistedWorkflow } from '@cotera/sdk/core';
import type { WorkflowNodeEditStrategy } from './types';
import { AgentNodeEditor } from './agent-node-editor';
import { ToolCallNodeEditor } from './tool-call-node-editor';
import { FilterNodeEditor } from './filter-node-editor';
import { DebounceNodeEditor } from './debounce-node-editor';
import { ForEachNodeEditor } from './for-each-node-editor';
import { EmitEventNodeEditor } from './emit-event-node-editor';
import { MapperNodeEditor } from './mapper-node-editor';
import { BucketNodeEditor } from './bucket-node-editor';
import { GroupByNodeEditor } from './group-by-node-editor';
import { RunWorkflowNodeEditor } from './run-workflow-node-editor';

const { WorkflowNodeType } = PersistedWorkflow;

const WORKFLOW_NODE_EDIT_STRATEGIES: Record<string, WorkflowNodeEditStrategy> =
  {
    [WorkflowNodeType.Agent]: {
      nodeType: WorkflowNodeType.Agent,
      title: 'Configure agent',
      Editor: AgentNodeEditor,
    },
    [WorkflowNodeType.ToolCall]: {
      nodeType: WorkflowNodeType.ToolCall,
      title: 'Configure tool call',
      Editor: ToolCallNodeEditor,
      autosave: true,
    },
    [WorkflowNodeType.Filter]: {
      nodeType: WorkflowNodeType.Filter,
      title: 'Configure filter',
      Editor: FilterNodeEditor,
    },
    [WorkflowNodeType.Debounce]: {
      nodeType: WorkflowNodeType.Debounce,
      title: 'Configure debounce',
      Editor: DebounceNodeEditor,
    },
    [WorkflowNodeType.ForEach]: {
      nodeType: WorkflowNodeType.ForEach,
      title: 'Configure for each',
      Editor: ForEachNodeEditor,
    },
    [WorkflowNodeType.EmitEvent]: {
      nodeType: WorkflowNodeType.EmitEvent,
      title: 'Configure emit event',
      Editor: EmitEventNodeEditor,
    },
    [WorkflowNodeType.Mapper]: {
      nodeType: WorkflowNodeType.Mapper,
      title: 'Configure mapper',
      Editor: MapperNodeEditor,
    },
    [WorkflowNodeType.Bucket]: {
      nodeType: WorkflowNodeType.Bucket,
      title: 'Configure bucket',
      Editor: BucketNodeEditor,
    },
    [WorkflowNodeType.GroupBy]: {
      nodeType: WorkflowNodeType.GroupBy,
      title: 'Configure group by',
      Editor: GroupByNodeEditor,
    },
    [WorkflowNodeType.RunWorkflow]: {
      nodeType: WorkflowNodeType.RunWorkflow,
      title: 'Configure workflow',
      Editor: RunWorkflowNodeEditor,
    },
  };

/** Returns the config editor for a node type, or null when it has none yet. */
export function resolveWorkflowNodeEditStrategy(
  type: string
): WorkflowNodeEditStrategy | null {
  return WORKFLOW_NODE_EDIT_STRATEGIES[type] ?? null;
}

export type {
  WorkflowNodeEditStrategy,
  WorkflowNodeEditorProps,
} from './types';
